import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeGroupHeading: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.remove-group-heading',
		defaultMessage: 'Delete group',
		description: 'Dialog heading for deleting a group',
	},
	removeTicketTypeHeading: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.remove-ticket-type-heading',
		defaultMessage: 'Remove request form',
		description:
			'Dialog heading for confirmation dialog when deleting the last request form in a group',
	},
	confirmMessage: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.confirm-message',
		defaultMessage: "This will permanently delete the group. It can't be undone.",
		description: 'Body message of dialog asking user to confirm deletion of group',
	},
	emptyGroupMessage: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.empty-group-message',
		defaultMessage: 'Removing this form will also delete the portal group.',
		description:
			'Body message of dialog warning user that removing the last request form in the group will also remove the group',
	},
	orphanRequestForms: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.orphan-request-forms',
		defaultMessage:
			'The following request {count, plural, one {form} other {forms}} will no longer be visible in your customer portal:',
		description:
			'Body message of dialog warning user that removing the group will mark some request forms unused',
	},
	confirmButton: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Label used in confirm button',
	},
	cancelButton: {
		id: 'portal-settings-request-groups.portal-group.remove-group-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label used in cancel button',
	},
});
